var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPhotoClosedFistGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.73 23.5701H79.98V10.8301L92.73 23.5701Z",
    fill: "#CDD9E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.73 23.5701H79.98V10.8301L92.73 23.5701Z",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.97 67.5502L95.0898 55.4802L112.03 46.1902L114.41 55.9602L118.51 53.9302L120.97 67.5502Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.81 49.26C129.546 49.8466 129.113 50.3412 128.567 50.6809C128.02 51.0206 127.385 51.19 126.742 51.1675C126.099 51.1449 125.478 50.9315 124.956 50.5544C124.435 50.1773 124.038 49.6535 123.816 49.0499C123.593 48.4462 123.555 47.79 123.707 47.1649C123.859 46.5397 124.194 45.9739 124.668 45.5395C125.143 45.1052 125.736 44.8219 126.372 44.7258C127.008 44.6297 127.658 44.7252 128.24 45C129.004 45.3667 129.595 46.0165 129.888 46.8118C130.181 47.607 130.153 48.4852 129.81 49.26Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3799 63.0301L100.58 17.5601L146.5 38.9701L125.09 84.8801L109.95 77.8201",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 127.65V47.04H26.64L30.69 54.89H35.93",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 127.65H2.5L13.77 72.7C14.004 71.4061 14.6767 70.2323 15.6748 69.3762C16.6729 68.5202 17.9355 68.0342 19.25 68H101.49C102.187 68.0305 102.868 68.215 103.484 68.5401C104.101 68.8652 104.638 69.3229 105.057 69.8804C105.476 70.4378 105.766 71.0811 105.907 71.764C106.047 72.4469 106.035 73.1525 105.87 73.83L94.87 127.67H87.61",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2699 121.66C77.2699 121.66 77.5299 117.48 80.0099 118.18C82.8999 118.86 80.9199 129.18 80.1499 132.08C79.3799 134.98 76.4399 138.81 76.4399 138.81V142.08H73.3799L71.1299 138.81",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.87 138.81L67.41 142.08H60.71V138.81C60.71 138.81 51.3 130.33 53.51 126.67C55.3 123.82 58.29 127.04 58.29 127.04",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4901 121.41C65.4901 121.41 64.2701 115.8 66.7901 115.58C69.3101 115.36 69.0601 121.15 69.0601 121.15",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0098 127.07V134.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6001 127.07V134.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2002 127.07V134.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5498 126C59.5498 126 57.5498 118.39 59.9398 117.58C62.3298 116.77 63.1898 121.41 63.1898 121.41",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3599 121.15C71.3599 121.15 71.4899 115.9 73.6799 116.15C75.8699 116.4 74.9799 121.26 74.9799 121.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1499 63.4201V15.4201C37.1499 14.4813 37.5229 13.5808 38.1867 12.917C38.8506 12.2531 39.751 11.8801 40.6899 11.8801H80.3399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 35.22H79.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 43.6001H75.78",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 51.98H79.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 60.3601H68.03",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPhotoClosedFistGrey);
export default __webpack_public_path__ + "static/media/folder_photo_closed_fist_grey.ee95230f7d5aad28aa2717b8145c390a.svg";
export { ForwardRef as ReactComponent };